import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Button,
  Paragraph
} from '@sopranodesign/pulse-components';

/**
 * Toolbar shown above a table when one or more rows are selected,
 * exposing the available bulk actions for the current selection.
 */
const BulkActionsBar = ({ count, onClear, actions }) => {
  if (!count) {
    return null;
  }

  return (
    <Flex border pad mb center between wrap="true" gap="sm">
      <Paragraph semiBold>{count} selected</Paragraph>
      <Flex center wrap="true" gap="sm">
        {actions}
        <Button variant="secondary" icon="xCircle" onClick={onClear}>
          Clear
        </Button>
      </Flex>
    </Flex>
  );
};

BulkActionsBar.propTypes = {
  count: PropTypes.number.isRequired,
  onClear: PropTypes.func.isRequired,
  actions: PropTypes.node
};

export default BulkActionsBar;
